import React, { useEffect, useState } from "react";
import { Route, Redirect, useHistory } from "react-router-dom";

import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { useAuth } from "~src/context/authContext";
import Navbar from "~src/layouts/navbar/Navbar";
import callAPI from "~src/utils/callAPI";
import PropagateLoader from "react-spinners/PropagateLoader";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function ProtectedRoute({ component: Component, ...rest }) {
  const auth = useAuth();
  const history = useHistory();
  const loggedInUser = localStorage.getItem("user");
  const [open, setOpen] = useState(false);
  const [shouldDashboardsReload, setShouldDashboardsReload] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    callAPI("GET", "logged_in/", "").then((res) => {
      if (!res.is_authenticated) {
        localStorage.removeItem("user");
        history.push("/login");
      } else {
        const userName = res.user;
        if (res.status === 200) {
          auth.signin(200, userName);
          // history.push(from.pathname);
        } else {
          auth.signin(400, userName);
        }
      }
      setIsLoading(false);
    });
  }, []);

  if (isLoading || loggedInUser === null || loggedInUser === undefined) {
    return (
      <>
        {/* <Navbar
          open={open}
          setOpen={setOpen}
          shouldDashboardsReload={shouldDashboardsReload}
          setShouldDashboardsReload={setShouldDashboardsReload}
        /> */}
        <PropagateLoader
          style={{ position: "fixed", top: "50%", left: "50%" }}
          color="primary"
        />
      </>
    );
  }

  const path = window.location.href.split("/");
  const mockup = path[path.length - 1];

  let heading = "";

  const mapping = {
    likelihood: "Likelihood of Purchase",
    Premium: "Premium Prediction",
    claimAmountForecast: "Claim Amount Forecast",
    fraudDetection: "Fraud Detection",
    // "fraudDetectionMember" : "Member Fraud Detection",
    churnMember: "Churn Prediction",
  };

  if (mockup in mapping) {
    heading = mapping[mockup];
  }

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1 }}>
        {/* <DrawerHeader /> */}
        {auth.user &&
        auth.user.replace(" ", "") !== "" &&
        auth.status === 200 ? (
          <Route
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
            render={({ match, location }) =>
              loggedInUser !== undefined && loggedInUser !== null ? (
                <div className="d-flex">
                  <main className="d-flex">
                    <div>
                      <Navbar
                        open={open}
                        setOpen={setOpen}
                        shouldDashboardsReload={shouldDashboardsReload}
                        setShouldDashboardsReload={setShouldDashboardsReload}
                        heading={heading}
                      />
                    </div>
                    <div style={{ width: "100%" }}>
                      <Component
                        open={open}
                        match={match}
                        sidebarOPen={open}
                        shouldDashboardsReload={shouldDashboardsReload}
                        setShouldDashboardsReload={setShouldDashboardsReload}
                      />
                    </div>
                  </main>
                </div>
              ) : (
                <Redirect
                  to={{
                    pathname: "/login",
                    state: { from: location },
                  }}
                />
              )
            }
          />
        ) : (
          ""
        )}
      </Box>
    </>
  );
}
